import { NextRequest, NextResponse } from 'next/server';
import { db } from '@/lib/db';

export async function GET() {
  try {
    console.log('🏋️ Fetching all trainers...');
    
    const { pool } = await import('@/lib/db');
    const [trainerRows] = await pool.execute(
      'SELECT * FROM trainers ORDER BY created_at DESC'
    );
    
    const trainers = (trainerRows as any[]).map(row => ({
      id: row.id,
      ownerEmail: row.owner_email,
      firstName: row.first_name,
      lastName: row.last_name,
      phone: row.phone,
      location: row.location,
      dateOfBirth: row.date_of_birth,
      bio: row.bio,
      profilePhoto: row.profile_photo,
      certifications: JSON.parse(row.certifications || '[]'),
      yearsOfExperience: row.years_of_experience,
      specializations: JSON.parse(row.specializations || '[]'),
      servicesOffered: JSON.parse(row.services_offered || '[]'),
      sessionPricing: row.session_pricing,
      availability: JSON.parse(row.availability || '{}'),
      preferredEnvironment: JSON.parse(row.preferred_environment || '[]'),
      travelDistance: row.travel_distance,
      additionalNotes: row.additional_notes,
      status: row.status,
      createdAt: row.created_at,
      updatedAt: row.updated_at,
    }));
    
    console.log(`✅ Found ${trainers.length} trainers`);
    
    return NextResponse.json({
      success: true,
      trainers
    });
  } catch (error) {
    console.error('❌ Error fetching trainers:', error);
    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    return NextResponse.json(
      { error: 'Failed to fetch trainers: ' + errorMessage },
      { status: 500 }
    );
  }
}
